<!--
  @template LaydownLocationGuardComponent Template
  
  Displays a warning message when the current location does not support laydown space.
  Shows the user which locations they need to select to access laydown features.
-->

<div *ngIf="!isLaydownAvailable" class="laydown-guard-container">
  <ion-card class="warning-card" color="warning">
    <ion-card-header>
      <ion-card-title>
        <ion-icon name="warning"></ion-icon>
        Laydown Space Not Available
      </ion-card-title>
    </ion-card-header>
    
    <ion-card-content>
      <p>
        <strong>{{ selectedLocation.label }}</strong> does not have laydown space available.
      </p>
      <p>
        Please select <strong>{{ laydownEnabledLocationLabels }}</strong> from the location dropdown 
        in the main menu to access laydown space features.
      </p>
    </ion-card-content>
  </ion-card>
</div>
